import { render } from "./ListeSecteurParametres.vue?vue&type=template&id=5c90c430&ts=true"
import script from "./ListeSecteurParametres.vue?vue&type=script&lang=ts"
export * from "./ListeSecteurParametres.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__